import { createFileRoute } from '@tanstack/react-router';

import AccountAndSecurity from 'component/view/Settings/AccountAndSecurity';

export const Route = createFileRoute('/n/_auth/settings/_layout/account-and-security/')({
  component: AccountAndSecurity,
});
